import recentSearchesStorageKeysCE from '~/filtered_search/recent_searches_storage_keys';

export default {
  ...recentSearchesStorageKeysCE,
  epics: 'epics-recent-searches',
  requirements: 'requirements-recent-searches',
  test_cases: 'test-cases-recent-searches',
  jira_issues: 'jira-issues-recent-searches',
  'ai-catalog': 'ai-catalog-recent-searches',
};
